export const successConstants = {
  subHeading: `# Your card has been activated`,
  successText: `#### Please note, funds may take up to 1 business day to be available on your card.`,
};
